@if (previousUrl) {
  <button class="back-button-container" (click)="goBack()">
    <img
      class="backButton"
      src="/assets/media/icons/shipmentDetails/goBack.svg"
      alt=""
    />
    <div class="backButton-fill">
      <img src="/assets/media/icons/shipmentDetails/goBack-fill.svg" alt="" />
      <p class="back-banner">BACK</p>
    </div>
  </button>
}
